/* Project Import will be here */
import * as actions from '../actions/timecardDefaultGroupBy.Action';
/* Project Import will be here */

/* Const,Let & Var will be here */
let initialState = {
    groupBy: {
        defaultGroupBy: '',
        timeCardGroupBy: ''
    }
};

/* Const,Let & Var will be here */

export default function (state = initialState, action) {
    switch (action.type) {
        case actions.DEFAULT_GROUP_BY:
            return {
                ...state,
                groupBy: {
                    ...state.groupBy,                  
                    defaultGroupBy: action.defaultGroupBy
                }
            };        
        case actions.TIMECARD_GROUP_BY:
            return {
                ...state,
                groupBy: {
                    ...state.groupBy,                  
                    timeCardGroupBy: action.timeCardGroupBy
                }
            };            
        default:
            return state;
    }
}